module.exports = __webpack_public_path__ + "static/media/benito-santos-mexico.854f2d46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/benito-santos-mexico.svg
// module id = 10
// module chunks = 0